export function animatedZoom(
  map: google.maps.Map,
  targetZoom: number,
  interval: number,
  position?: google.maps.LatLngLiteral | google.maps.LatLng,
  zoomIn = true,
) {
  let currentZoom = map.getZoom() || 0;
  const zoomInterval = setInterval(() => {
    if (zoomIn ? currentZoom < targetZoom : currentZoom > targetZoom) {
      zoomIn ? currentZoom++ : currentZoom--;
      position && map.panTo(position);
      map.setZoom(currentZoom);
    } else {
      clearInterval(zoomInterval);
    }
  }, interval);
}
